import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const KEY = "df_investor_ack";

function read() {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}
function write() {
  try { sessionStorage.setItem(KEY, "1"); } catch { /* storage unavailable: gate re-asks on next page */ }
}

// Wraps the investment pages. Nothing behind the gate renders until the visitor
// confirms they are a relevant person; the confirmation lasts for the browser session.
export default function InvestorGate({ children }) {
  const [ok, setOk] = useState(read);
  const navigate = useNavigate();

  useEffect(() => {
    if (ok) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [ok]);

  if (ok) return children;

  return (
    <div className="gate-modal" role="dialog" aria-modal="true" aria-labelledby="gate-title">
      <div className="gate-card">
        <div className="eyebrow">Before you continue</div>
        <h2 id="gate-title">The pages beyond this point describe private investment vehicles.</h2>
        <p>
          They are not authorised by the Financial Conduct Authority and may only be promoted in the
          United Kingdom to investment professionals and high net worth entities as defined in the
          Financial Promotion Order 2005, or to persons outside the United Kingdom to whom they may
          lawfully be communicated. Capital is at risk and investments are not covered by the Financial
          Services Compensation Scheme.
        </p>
        <p>
          Read our <Link to="/investor-access">Investor access statement</Link> for the full definition
          of a relevant person.
        </p>
        <div className="gate-actions">
          <button type="button" className="btn btn-primary" onClick={() => { write(); setOk(true); }}>
            I confirm that I am a relevant person and wish to continue
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => navigate("/")}>
            I am not. Take me back
          </button>
        </div>
        <p className="gate-foot">
          Your confirmation is stored in your browser for this session only. We do not record your identity at this stage.
        </p>
      </div>
    </div>
  );
}
